module.exports = __webpack_public_path__ + "img/DesertNoContactsFound.8fe604f6.png";